module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8f303509bdecaa73e6ff2a5fbb909b44.png";